




import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'badge-logofsc-component',
})
export default class LogoFscComponent extends Vue {
}
